{
  "name": "seb",
  "version": "25.12.1.8",
  "license": "MIT",
  "engines": {
    "node": ">=22"
  },
  "scripts": {
    "ng": "nx",
    "start": "nx serve",
    "build": "nx build",
    "lint": "eslint && npm run lint:styles",
    "lint:styles": "stylelint {apps,libs}/**/*.scss",
    "lint:nx": "nx run-many --parallel 1 --exclude='seb' -t lint",
    "test:ci": "nx run-many --parallel 1 --exclude='seb' --coverage.enabled=true -t test",
    "test": "vitest",
    "test:verbose": "vitest --reporter=verbose",
    "sonar": "sonar-scanner",
    "prepare": "husky",
    "check": "madge -c --extensions js,ts apps/**/* libs/**/*",
    "build:all": "nx run-many --parallel 5 -t build -p web-krups web-moulinex web-rowenta web-tefal",
    "web-moulinex:dev:ssr": "export SERVER_REQUEST_ORIGIN=sandbox.moulinex.fr; nx run web-moulinex:build:ssr --configuration development && node --env-file=.env --inspect dist/apps/web-moulinex/server/server.mjs",
    "web-moulinex:start": "nx run web-moulinex:serve --port 4000 --host sandbox.moulinex.fr",
    "web-moulinex:start:https": "nx run web-moulinex:serve --ssl --port 443 --host sandbox.moulinex.fr",
    "web-moulinex:start:ssr": "npm run web-moulinex:build:ssr && node --env-file=.env dist/apps/web-moulinex/server/server.mjs",
    "web-moulinex:build:ssr": "nx run web-moulinex:build",
    "web-moulinex:stats": "esbuild-visualizer --filename dist/apps/web-moulinex/stats.html --metadata dist/apps/web-moulinex/stats.json",
    "web-tefal:dev:ssr": "export SERVER_REQUEST_ORIGIN=sandbox.tefal.fr; nx run web-tefal:build:ssr --configuration development && node --env-file=.env --inspect dist/apps/web-tefal/server/server.mjs",
    "web-tefal:start": "nx run web-tefal:serve --port 4000 --host sandbox.tefal.fr",
    "web-tefal:start:https": "nx run web-tefal:serve --ssl --port 443 --host sandbox.tefal.fr",
    "web-tefal:start:ssr": "npm run web-tefal:build:ssr && node --env-file=.env dist/apps/web-tefal/server/server.mjs",
    "web-tefal:build:ssr": "nx run web-tefal:build",
    "web-tefal:stats": "esbuild-visualizer --filename dist/apps/web-tefal/stats.html --metadata dist/apps/web-tefal/stats.json",
    "web-krups:dev:ssr": "export SERVER_REQUEST_ORIGIN=sandbox.krups.fr; nx run web-krups:build:ssr --configuration development && node --env-file=.env --inspect dist/apps/web-krups/server/server.mjs",
    "web-krups:start": "nx run web-krups:serve --port 4000 --host sandbox.krups.fr",
    "web-krups:start:https": "nx run web-krups:serve --ssl --port 443 --host sandbox.krups.fr",
    "web-krups:start:ssr": "npm run web-krups:build:ssr && node --env-file=.env dist/apps/web-krups/server/server.mjs",
    "web-krups:build:ssr": "nx run web-krups:build",
    "web-krups:stats": "esbuild-visualizer --filename dist/apps/web-krups/stats.html --metadata dist/apps/web-krups/stats.json",
    "web-rowenta:dev:ssr": "export SERVER_REQUEST_ORIGIN=sandbox.rowenta.fr; nx run web-rowenta:build:ssr --configuration development && node --env-file=.env --inspect dist/apps/web-rowenta/server/server.mjs",
    "web-rowenta:start": "nx run web-rowenta:serve --port 4000 --host sandbox.rowenta.fr",
    "web-rowenta:start:https": "nx run web-rowenta:serve --ssl --port 443 --host sandbox.rowenta.fr",
    "web-rowenta:start:ssr": "npm run web-rowenta:build:ssr && node --env-file=.env dist/apps/web-rowenta/server/server.mjs",
    "web-rowenta:build:ssr": "nx run web-rowenta:build",
    "web-rowenta:stats": "esbuild-visualizer --filename dist/apps/web-rowenta/stats.html --metadata dist/apps/web-rowenta/stats.json",
    "docs:json": "compodoc -p ./libs/web-design-system/tsconfig.doc.json -e json -d ./libs/web-design-system/documentation",
    "storybook:start": "nx run web-design-system:storybook",
    "storybook:build": "nx run web-design-system:build-storybook",
    "storybook:css-theming": "sass libs/web-design-system/stories/theming:libs/web-design-system/stories/theming --style=compressed -I node_modules --no-source-map",
    "storybook:css": "npm run storybook:css-theming",
    "lh:desktop": "lhci autorun --config=./lighthouserc-desktop.js",
    "lh:mobile": "lhci autorun --config=./lighthouserc-mobile.js"
  },
  "private": true,
  "dependencies": {
    "@angular-slider/ngx-slider": "^19.0.0",
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/google-maps": "^19.2.19",
    "@angular/localize": "^19.2.14",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/platform-server": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@angular/service-worker": "^19.2.14",
    "@angular/ssr": "^19.2.15",
    "@angular/youtube-player": "^19.2.19",
    "@fontsource/open-sans": "^5.2.7",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@ng-select/ng-select": "^14.5.6",
    "@ngrx/effects": "^19.2.1",
    "@ngrx/router-store": "^19.2.1",
    "@ngrx/store": "^19.2.1",
    "@ngx-translate/core": "^16.0.4",
    "@spartacus/cart": "~2211.42.0",
    "@spartacus/checkout": "~2211.42.0",
    "@spartacus/core": "~2211.42.0",
    "@spartacus/order": "~2211.42.0",
    "@spartacus/product": "~2211.42.0",
    "@spartacus/setup": "~2211.42.0",
    "@spartacus/smartedit": "~2211.42.0",
    "@spartacus/storefinder": "~2211.42.0",
    "@spartacus/storefront": "~2211.42.0",
    "@spartacus/styles": "~2211.42.0",
    "@spartacus/user": "~2211.42.0",
    "angular-oauth2-oidc": "^19.0.0",
    "axios": "^1.12.2",
    "axios-cache-interceptor": "^1.8.3",
    "cheerio": "^1.1.2",
    "compression": "^1.8.1",
    "cookie-parser": "^1.4.7",
    "deep-equal": "^2.2.3",
    "express": "^4.21.2",
    "i18n-iso-countries": "^7.14.0",
    "i18next": "^24.2.3",
    "i18next-http-backend": "^3.0.2",
    "i18next-resources-to-backend": "^1.2.1",
    "iframe-resizer": "^4.3.7",
    "jquery": "^3.7.1",
    "moment": "^2.30.1",
    "ngx-device-detector": "^9.0.0",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-tag-commander": "^3.0.1",
    "node-js-marker-clusterer": "^1.0.0",
    "rxjs": "^7.8.2",
    "swiper": "^8.4.7",
    "ts-loader": "^9.5.4",
    "tslib": "^2.8.1",
    "uuid": "~11.1.0",
    "what-input": "^5.2.12",
    "xml": "^1.0.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "~1.21.1",
    "@analogjs/vitest-angular": "~1.21.1",
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular-devkit/core": "^19.2.15",
    "@angular-devkit/schematics": "^19.2.15",
    "@angular-eslint/builder": "^19.8.1",
    "@angular-eslint/eslint-plugin": "^19.8.1",
    "@angular-eslint/eslint-plugin-template": "^19.8.1",
    "@angular-eslint/schematics": "^19.8.1",
    "@angular-eslint/template-parser": "^19.8.1",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@angular/language-service": "^19.2.14",
    "@chromatic-com/storybook": "^4.1.1",
    "@commitlint/cli": "^20.0.0",
    "@commitlint/config-conventional": "^20.0.0",
    "@compodoc/compodoc": "^1.1.30",
    "@jscutlery/swc-angular": "~0.20.5",
    "@jscutlery/swc-angular-plugin": "~0.20.5",
    "@lhci/cli": "^0.15.1",
    "@nx/angular": "^21.5.3",
    "@nx/eslint": "^21.5.3",
    "@nx/eslint-plugin": "^21.5.3",
    "@nx/js": "^21.5.3",
    "@nx/storybook": "^21.5.3",
    "@nx/vite": "^21.5.3",
    "@nx/web": "^21.5.3",
    "@nx/workspace": "^21.5.3",
    "@schematics/angular": "^19.2.15",
    "@spartacus/schematics": "~2211.42.0",
    "@storybook/addon-a11y": "^9.1.8",
    "@storybook/addon-docs": "^9.1.8",
    "@storybook/angular": "^9.1.8",
    "@storybook/preset-scss": "^1.0.3",
    "@stylistic/eslint-plugin": "^5.4.0",
    "@swc-node/register": "~1.10.0",
    "@swc/core": "~1.10.0",
    "@swc/helpers": "~0.5.17",
    "@types/compression": "^1.8.1",
    "@types/cookie-parser": "^1.4.9",
    "@types/deep-equal": "^1.0.4",
    "@types/express": "^4.x",
    "@types/google.maps": "^3.58.1",
    "@types/iframe-resizer": "^4.0.0",
    "@types/newrelic": "^9.14.8",
    "@types/node": "22.14.1",
    "@types/xml": "^1.0.11",
    "@typescript-eslint/eslint-plugin": "^8.44.1",
    "@typescript-eslint/parser": "^8.44.1",
    "@vitest/coverage-v8": "^3.2.4",
    "@vitest/ui": "^3.2.4",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.36.0",
    "eslint-plugin-storybook": "^9.1.8",
    "eslint-plugin-unused-imports": "^4.2.0",
    "generate-documentation-stories": "file:generate-documentation-stories-4.1.1.tgz",
    "husky": "^9.1.7",
    "immer": "^10.1.3",
    "jiti": "2.6.0",
    "jsdom": "~27.0.0",
    "lint-staged": "^16.2.1",
    "madge": "^8.0.0",
    "nx": "^21.5.3",
    "postcss-scss": "^4.0.9",
    "remove-attr": "^0.0.15",
    "sass-loader": "^16.0.5",
    "storybook": "^9.1.8",
    "style-loader": "^4.0.0",
    "stylelint": "^16.24.0",
    "stylelint-scss": "^6.12.1",
    "ts-node": "10.9.2",
    "typescript": "5.8.2",
    "unplugin-swc": "^1.5.7",
    "vite": "^6.3.5",
    "vitest": "^3.2.4",
    "vitest-sonar-reporter": "^2.0.4",
    "vitest-when": "^0.8.0"
  },
  "lint-staged": {
    "{apps,libs}/**/*.{ts,js,html}": "eslint",
    "{apps,libs}/**/*.{scss,css}": "stylelint"
  },
  "overrides": {
    "swiper": {
      "@angular/common": ">=19",
      "@angular/core": ">=19"
    }
  }
}
